import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { KPF } from '../../master-data-management/kpf/entities/KPF.js';
import { CapacityRequest } from './CapacityRequest.js';

@Entity()
export class CapacityGuestDay extends MongoEntity {
  static override _class = 'CapacityGuestDay';
  static override _collectionName = 'capacity-guest-days';

  @validate(nonOptional())
  @Field(() => String)
  public requestId: Maybe<string>;

  @DataLoadedField(() => CapacityRequest, ({ requestId }) => requestId)
  public request: Maybe<CapacityRequest>;

  @validate(nonOptional())
  @Field(() => DateTime)
  public day: Maybe<DateTime>;

  @Field(() => String)
  public vorname: Maybe<string>;

  @Field(() => String)
  public nachname: Maybe<string>;

  @Field(() => String)
  public telefonBewerber: Maybe<string>;

  @Field(() => String)
  public bewerbungslink: Maybe<string>;

  @Field(() => DateTime, { default: v => v ?? DateTime.now() })
  public createdAt: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(() => String)
  public KPFID: Maybe<string>;

  @DataLoadedField(() => KPF, ({ KPFID }) => KPFID)
  public KPF: Maybe<KPF>;
}
